import 'jquery';
import 'metismenu';
import tippy from 'tippy.js';
import { roundArrow } from 'tippy.js';
import { getBreakpoint } from './helpers';

jQuery(function () {
  $(window).on('resize.navbar', function () {
    const $navbar = $('[data-navbar]');
    const $overlapElement = $('#main [data-navbar-overlap]').first();
    let navbarBreakpoint = $overlapElement?.data('navbar-overlap');

    $overlapElement?.css('padding-top', '');

    if (navbarBreakpoint && $(window).width() >= getBreakpoint(navbarBreakpoint)) {
      if ($navbar.outerHeight() >= $overlapElement.offset().top) {
        $navbar.addClass('absolute');

        if ($overlapElement.data('navbar-overlap-padding')) {
          $overlapElement.css('padding-top', $navbar.outerHeight());
        }
      }
    } else {
      $navbar.removeClass('absolute');
    }
  }).trigger('resize.navbar');

  $('[data-toggle-nav]').on('click', function (e) {
    const target = $(this).data('toggle-nav');
    const $target = $(target);

    if (! $target.length) {
      return true;
    }

    e.preventDefault();

    const $togglers = $(`[data-toggle-nav="${target}"]`);

    if (! $target.hasClass('active')) {
      $togglers.addClass('active').find('animate[data-active]').each(function () {
        $(this).get(0).beginElement();
      });

      $target.addClass('active');
    } else {
      $togglers.removeClass('active').find('animate[data-inactive]').each(function () {
        $(this).get(0).beginElement();
      });

      $target.removeClass('active');
    }
  });

  const mediaQuery = window.matchMedia('(max-width: 768px)');
  function handleMaxWidthChanged(evt) {
    var isMobile =
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      ) && evt.matches;
    $('#menu-mega-menue').metisMenu(isMobile ? { toggle: false } : 'dispose');
  }
  handleMaxWidthChanged(mediaQuery);
  mediaQuery.addEventListener('change', handleMaxWidthChanged);

  $('[data-link-animation]').on('mouseenter', function () {
    $(this).find('animate[data-enter]').get(0).beginElement();
  }).on('mouseleave', function () {
    $(this).find('animate[data-leave]').get(0).beginElement();
  });

  $('[data-tippy]').each(function () {
    const id = $(this).data('tippy');
    const $el = $(`#${id}`);

    if (! $el.length) {
      return true;
    }

    tippy($(this).get(0), {
      allowHTML: true,
      animation: 'shift-toward-subtle',
      arrow: roundArrow,
      content: $el.html(),
      interactive: true,
      offset: [0, 12],
      popperOptions: {
        modifiers: [
          {
            name: 'preventOverflow',
            options: {
              padding: 16,
            },
          },
        ],
      },
      theme: 'light',
      trigger: 'mouseenter focus click',
      zIndex: 99999,
    });
  });

  $('[data-show-select]').on('change', function () {
    const $option = $(this).find(':selected');

    if ($option.data('show') && $(`#${$option.data('show')}`).length) {
      $(`#${$option.data('show')}`).show().siblings().hide();
    }
  }).trigger('change');

  $('video').on('ended', function () {
    $(this).get(0).currentTime = 0;
  });

});
